/**
 * @file 获取资源列表
 * @author liudy
 */
import Api from '../../path';
import { HomeworkSubmitStatus, SwitchNum } from '@umu/umu-types';
import { fetchData, fetchDataSync, IOption } from '@umu/umu-fetch';

export enum homeworkSessionTypeEnum {
    VIDEO = '11',
    DOCUMENTS = '14',
    IMAGE_ARTICLE = '15',
}

export enum EVideoSource {
    RECORD = 2,
    UPLOAD = 1,
}
export interface ISaveHomeworkInput {
    parent_id: number;
    homework_id?: number;
    homework_data: string; // {type: homeworkSessionTypeEnum; title: string }
    submit_status: HomeworkSubmitStatus;
    video_source?: EVideoSource;
    speaker_num?: number;
    submit_to_practice?: SwitchNum;
    fetchOption?: IOption;
}

export interface ISaveHomeworkOutput {
    homework_id: number;
    des_homework_id: string;
    share_url: string;
}

export const saveHomework = fetchDataSync((data: ISaveHomeworkInput): Promise<IResponse<ISaveHomeworkOutput>> => {
    return fetchData(
        Api.HOMEWORK_SAVE,
        data,
        data.fetchOption || {
            silent: false,
        },
    ).then((res: IResponse<ISaveHomeworkOutput>) => {
        return res;
    });
});

export const saveHomeworkPromise = (data: ISaveHomeworkInput): Promise<IResponse<ISaveHomeworkOutput>> => {
    return fetchData(Api.HOMEWORK_SAVE, data).then((res: IResponse<ISaveHomeworkOutput>) => {
        return res;
    });
};

export const saveHomeworkKeywords = (data: { parent_id: string; keywords: string }): Promise<IStatusResponse> => {
    return fetchData(Api.SAVE_HOMEWORK_KEYWORDS, { ...data, parent_type: 4 });
};
